/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGongIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-gong" */ './gong-icon').then((m) => m.GongIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/gong/icon' },
);

const LazyGongSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-gong-search-result" */ './gong-search-result-icon').then(
			(m) => m.GongSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/gong/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GongIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGongIconComponent />
	</Suspense>
);

export const GongSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGongSearchResultIconComponent />
	</Suspense>
);
